export function buildPath(...segments: string[]): string {
  return segments.filter(Boolean).join('/');
}

export function truncateString(text: string, maxLength: number): string {
  if (!text || maxLength <= 0) {
    return '';
  }
  
  if (text.length <= maxLength) {
    return text;
  }
  
  return text.substring(0, maxLength) + '...';
}
